export const co = {
  sodimac: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Entra y descubre nuestro catálogo online en $xlp_name$ $facet_value$. Compra en falabella.com de manera fácil y segura.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ $xlp_name$ a precios increíbles, navega en falabella.com y aprovecha nuestros precios online.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tus marcas favoritas en falabella.com, encuentra $xlp_name$ de diferentes modelos a precios increíbles.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  tottus: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Entra y descubre nuestro catálogo online en $xlp_name$ $facet_value$. Compra en falabella.com de manera fácil y segura.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ $xlp_name$ a precios increíbles, navega en falabella.com y aprovecha nuestros precios online.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tus marcas favoritas en falabella.com, encuentra $xlp_name$ de diferentes modelos a precios increíbles.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  linio: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Compra $facet_value$ $xlp_name$ a un precio increíble. Haz click y conoce todas nuestras ofertas online de tus marcas favoritas.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Conoce nuestras ofertas online de $facet_value$ en $xlp_name$ y realiza tus compras online de manera fácil y segura en Linio $country$. ¡Haz click!',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'En Linio $country$ encuentra $xlp_name$ de las mejores marcas y diferentes modelos, elige el mejor precio para ti y aprovecha nuestras promociones.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ ofertas',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Linio $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  marketplace: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Entra y descubre nuestro catálogo online en $xlp_name$ $facet_value$. Compra en falabella.com de manera fácil y segura.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ $xlp_name$ a precios increíbles, navega en falabella.com y aprovecha nuestros precios online.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tus marcas favoritas en falabella.com, encuentra $xlp_name$ de diferentes modelos a precios increíbles.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  homecenter: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$ $facet_value$ a un increíble precio y aprovecha todas las ventajas de comprar en Homecenter $country$, realiza tus compras de manera fácil y segura en tu Tienda Falabella $country$.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Compra online $facet_value$ en $xlp_name$ con increíbles descuentos. Renueva tu hogar con los productos que tenemos para ti ¡Entra a Homecenter $country$ y descúbrelo ahora mismo!',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Descubre nuestras ofertas en $xlp_name$ conoce nuestro catálogo online y elige la mejor opción para ti ¡Aprovecha lo descuentos de Homecenter $country$!',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Homecenter $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  so_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Entra y descubre nuestro catálogo online en $xlp_name$ $facet_value$. Compra en falabella.com de manera fácil y segura.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ $xlp_name$ a precios increíbles, navega en falabella.com y aprovecha nuestros precios online.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tus marcas favoritas en falabella.com, encuentra $xlp_name$ de diferentes modelos a precios increíbles.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: true,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
      isShopTheProjectEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
  to_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      AZUL: '#0b108c',
      BLANCO: '#ffffff',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      ENVIO_GRATIS_LABEL_AMOUNT: '$149.000',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que hay ciertas categorías para los que no aplica: productos que, por su naturaleza, no pueden ser devueltos porque pueden deteriorarse o caducar, han sido confeccionados a medida y son de uso personal.',
      RETURN_POLICY_PARA_1_1:
        'Queremos que estés feliz con tu compra y que sientas nuestro respaldo en todo momento. Por eso, contamos con garantías y derechos que puedes ejercer si necesitas hacer una devolución.',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      CHAT_BOT: 'ChatBot',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORESDISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      PREVIOUS: 'Anterior',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      AVAILABILITY: 'Disponibilidad',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      CANCEL: 'Cancelar',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Encuentra tus marcas favoritas como: $xlp_name$ y muchas más con grandes ofertas en falabella.com, aprovecha nuestros envíos gratis en productos seleccionados.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Ten en cuenta nuestra ',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver comentarios',
      SELECTED_FILTERS: 'Filtro seleccionado',
      MORE_PRODUCTS_FROM_COLLECTION: 'Combinados siempre van mejor',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      FREE_SHIPPING_SIZES_3P: 'XS3,XS2,XS,S,M,ML,LO,L,XL,xs3,xs2,xs,s,m,ml,lo,l,xl',
      PICKUP_INSTORE_PLEASE_SELECT: 'Revisar disponibilidad',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Entra y descubre nuestro catálogo online en $xlp_name$ $facet_value$. Compra en falabella.com de manera fácil y segura.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ $xlp_name$ a precios increíbles, navega en falabella.com y aprovecha nuestros precios online.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestras garantías y derechos',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Barrio',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      LOW_STOCK_WARNING: 'Los productos de tu Bolsa de Compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      PLANES: 'PLANES',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      product: 'Product',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '149000',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      MENU: 'Menu',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es vendido en nombre y por cuenta de un seller de Falabella y despachado por Falabella. Disfruta los beneficios de comprar en Falabella.com: Despacho a domicilio, devoluciones fáciles y nuestro servicio al cliente.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING_3P: 'G230101, G2302, G230504',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: 'Ábrela y obtén $45.000 de descuento extra.',
      RETURN_POLICY_INFO_HARDLINE: '',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tus marcas favoritas en falabella.com, encuentra $xlp_name$ de diferentes modelos a precios increíbles.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Encuentra variedad de productos de $xlp_name$. Entra a falabella.com y conoce nuestras ofertas y promociones.',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: '',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $45.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $45.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      FREE_SHIPPING_SIZES: 'XS3,XS2,XS,S,M,ML,xs3,xs2,xs,s,m,ml',
      ITEM_ADDED_IN_CART: ' Producto(s) agregado(s) a la bolsa de compras',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART:
        'G11040101,G11040102,G11040103,G11040104,G11040105,G11040106,G11040107,G11040108,G11040109,G11040110,G11040111,G11040112,G11040113,G11010101,G11010102',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      CIUDAD: 'Ciudad',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'Ver Bolsa de Compras',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SELLER_NAMES_FOR_FREE_SHIPPING:
        'MADERKIT S.A,HOGAR VENECIA MUEBLES SAS,VIRTUAL MUEBLES,MABE,RTA MUEBLES,CHALLENGER,Colchones Fantasia,Haceb',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101,J08020104',
      ORDER_BY: 'Ordenar',
      PLANS_DETAILS_GB_LABEL: 'GB',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        'Si tu producto falla, debes contactar al servicio técnico que corresponda para que te podamos ayudar. Considera que el plazo de la garantía empieza a contar desde la fecha en que recibiste el producto.',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SKU_COLLECTION_FOR_FREE_SHIPPING: 'FREESHIPPING1,FREESHIPPING2',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G19070104,G19070208,G19070301,G19070107,G19070110,G19070109,G190704,G19070102,G180101,G180102,G180301,G180401,G180201,G180202,G180302',
      CIUDAD_TEXT: 'Ciudad',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¿AÚN NO TIENES TU CMR?',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      ORDER_BY_MOBILE: 'Ordenar',
      RETURN_POLICY_PARA_3_3:
        'Productos de uso personal, alimentos, bebidas, suplementos, medicamentos, vitaminas, eléctricos, electrodomésticos, electrónicos, tecnología, colchones, muebles y máquinas deportivas.',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_1: '',
      RETURN_POLICY_LIST_3:
        '<b style="font-weight: bold">Tienes 30 días calendario</b>  desde que recibes el producto para pedir su devolución. Ten en cuenta que hay productos de ciertas categorías no se pueden devolver si cambias de opinión:',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      BUY_NOW_BUTTON_TEXT: 'COMPRAR AHORA',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'sodimac, falabella',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Tienes 5 días hábiles</b> para devolver por ley.',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      RETURN_POLICY_PARA_2_2: 'No aplica para productos de uso personal y confeccionados a medida.',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: '30 días para cambios y devoluciones.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '149000',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho de retracto y garantías',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SELECTION_SIZE: 'Talla:',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      RETURN_POLICY_MODAL_HEADER_2: '<b style="font-weight: bold">Derecho de retracto:</b>',
      RETURN_POLICY_MODAL_HEADER_3: '<b style="font-weight: bold">Satisfacción garantizada:</b>',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      RETURN_POLICY_MODAL_HEADER_4: '<b style="font-weight: bold">Garantía legal:</b>',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      WARRANTY_LABEL_PREFIX: '',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Conoce nuestra oferta de $xlp_name$ y no te pierdas los mejores precios.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isBuyNowEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: false,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: false,
      isPickupInStoreVisibleInPDP: true,
      isReaconditionedLinkEnabledPDP: false,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isRedirect301EnabledForBrand: true,
      isGeoLocationEnabled: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isSellerSkuIdColombiaEnabled: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      isSellerBusinessNameEnabled: false,
      isVwoEnabled: 'true',
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: true,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWebPushNotificationEnabled: true,
      isBreadcrumbsV1Enabled: false,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: true,
      isInternationalBuyVisiblePDP: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: false,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: true,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      newFreeShippingEnabled: false,
      isNewOmniChannelExperience: true,
      enableSponsoredInRecommendation: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      showPriceValidity: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.co/falabella-co/page/devoluciones',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.co',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.co',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.co/falabella-co/myaccount/myLists',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com.co/falabella-co/page/cmr-enlinea?utm_source=falabella_naranja&utm_medium=placement&utm_campaign=falabella_naranja_placements_web&utm_content=cmr_originacion_falanaranja',
      SERVICES_CO_TIENDA: '',
      BASKET_PAGE_URI: 'https://www.falabella.com.co/falabella-co/basket',
      moreWarrantyBenefitsLink: 'https://www.falabella.com.co/falabella-co/page/garantia-extendida',
    },
    facetLabels: {
      'f.derived.variant.freeShipping':
        '<p>En productos seleccionados por compras desde&nbsp;<strong>$149.990</strong></p>',
      'f.derived.variant.activeEvent': '<p>Sale</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/faco_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1672238921746-0',
            folder: '/21632469435/faco_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/faco_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Uso de repuestos originales',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Mano de Obra Certificada',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Transportes y fletes en caso de requerimiento',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Extensión de la garantía de fábrica de 1 a 4 años',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Daño accidental primeros 30 días (una vez entregado el producto)',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura Nacional',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Visitas técnicas y diagnósticos gratis',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía de reparación-uso',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat900969',
        'cat5521012',
        'cat13190940',
        'cat8850957',
        'cat13320960',
        'CATG33461',
        'CATG33460',
        'cat8790940',
        'CATG34933',
        'cat1201309',
        'CATG34850',
        'cat13190942',
        'CATG33737',
        'cat13360950',
        'cat13190943',
        'cat8790941',
        'CATG33462',
        'CATG33738',
        'cat6871001',
        'CATG33463',
        'CATG33464',
        'CATG33465',
        'cat5930952',
        'cat7310960',
        'cat7310958',
        'cat7310959',
        'cat4670965',
        'cat5530965',
        'cat4960962',
        'cat14591176',
        'cat5530966',
        'cat8430941',
        'cat4960965',
        'cat4960963',
        'cat14590995',
        'cat4960964',
        'cat8840945',
        'cat14590996',
        'cat4960966',
        'cat7310956',
        'cat5530968',
        'cat7310955',
        'CATG33466',
        'cat740959',
        'cat8820970',
        'cat731023',
        'CATG33467',
        'cat5481019',
        'cat260943',
        'CATG34270',
        'CATG34267',
        'CATG34268',
        'CATG34271',
        'CATG34272',
        'CATG34269',
        'CATG34273',
        'CATG34274',
        'cat2321031',
        'CATG32258',
        'cat1660957',
        'cat13320959',
        'cat5510962',
        'cat10360978',
        'cat13320950',
        'CATG34936',
        'cat13320947',
        'cat11520980',
        'cat1411008',
        'cat5441005',
        'cat5441006',
        'CATG33468',
        'CATG33469',
        'cat5441004',
        'cat5510961',
        'cat7530993',
        'cat7530997',
        'cat7530995',
        'cat14230981',
        'CATG31966',
        'cat7530996',
        'cat1711094',
        'CATG33471',
        'CATG33472',
        'cat5440996',
        'cat6570940',
        'cat6570941',
        'cat7400997',
        'cat5100940',
        'cat7400998',
        'cat14591170',
        'cat14591169',
        'cat14591171',
        'cat7100944',
        'cat14591000',
        'cat14591002',
        'cat14591003',
        'cat4670964',
        'cat4960971',
        'cat9710983',
        'CATG33845',
        'cat5521009',
        'cat10030947',
        'cat14590997',
        'cat4960969',
        'cat14590998',
        'cat7161061',
        'CATG34912',
        'CATG34909',
        'CATG34903',
        'CATG34906',
        'cat4960970',
        'cat13691005',
        'cat5810997',
        'cat14590999',
        'cat14591001',
        'cat14591006',
        'cat14591007',
        'cat14591004',
        'cat14591005',
        'cat4960968',
        'cat790973',
        'cat7100945',
        'cat1031787',
        'cat5481018',
        'cat5540944',
        'cat4310967',
        'cat11840969',
        'cat1181119',
        'cat2571192',
        'cat8700945',
        'cat1831262',
        'cat1200963',
        'cat2571199',
        'cat10890960',
        'CATG33473',
        'cat1181121',
        'CATG34276',
      ],
      facetsWithLink: [],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
            intl: 'Devolver es fácil y gratis',
          },
          info: {
            default: '',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestras garantías y derechos.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.co/falabella-co',
        linio: 'https://linio.falabella.com.co/linio-co',
        homecenter: 'https://homecenter.falabella.com.co/homecenter-co',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      freeShippingConfig: {
        facetEnabled: true,
        sfsEnabled: true,
        pfsEnabled: true,
      },
      pdConfiguration: {
        source: 'browse',
        campaignNames: ['PRICEAPP', 'PRECIO+PRO', 'CES_ORO', 'CES_BLACK', 'ENVIO GRATIS 3P', 'ENVIO_GRATIS_3P'],
        promotionTypes: [],
        xlpEnabled: false,
      },
    },
  },
};
